import React from "react";
import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import { Helmet } from "react-helmet";
import "../../../../styles/Pages/Financial/Accountant/Revenue/Revenue.style.css";
import RevenueGraph from "../../../../components/PagesComponents/Financial/Accountant/Revenue/RevenueGraph.component";
import RevenuePieChart from "../../../../components/PagesComponents/Financial/Accountant/Revenue/RevenuePieChart.component";
import NumberCard from "../../../../components/Universal/NumberCard.component";

const Body = ({ donutChartData, lineChartData }) => {
  return (
    <section className="accountentRevenue">
      <Helmet>
        <title>Revenue</title>
        <meta
          name="description"
          content="A powerful organization management system to streamline workflows and improve efficiency."
        />
        <meta
          name="keywords"
          content="organization management, workflow automation, business management, employee tracking"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <PageHeader title={"Main stream revenue"} />
      <div className="mainContainer">
        <div className="revenueContainer">
          <div className="revenueGraph">
            <RevenueGraph graphData={lineChartData} />
          </div>
          <div className="revenuePieChart">
            <RevenuePieChart donutChartData={donutChartData} />
          </div>
        </div>
        <div className="secondaryContainer">
          <div className="ratioInfoContainer">
            <div className="mainStreamEnrollmentRatio">
              <h3 className="ratioTitle">Main stream enrollment ratio</h3>
              <div>
                (One time enrollment) : (Monthly enrollment) : (Extra benefitial
                enrollment)
              </div>
              <h1 style={{ fontSize: "2rem" }}>
                <span className="unit">3</span>:<span className="unit">2</span>:
                <span className="unit">1</span>
              </h1>
            </div>
            <div className="feeSection">
              <span>Click here to go to fees section</span>
            </div>
          </div>
          <div className="numbersDataContainer">
            <NumberCard
              NumberData={{
                title: "One Time Enrollment",
                amount: "36,00,000",
                percentageChange: "+3.4%",
                note: "Good For Business",
                noteColor: "color-greenColor",
              }}
            />
            <NumberCard
              NumberData={{
                title: "Monthly Enrollment",
                amount: "24,00,000",
                percentageChange: "+3.4%",
                note: "Good For Business",
                noteColor: "color-greenColor",
              }}
            />
            <NumberCard
              NumberData={{
                title: "Extra Benefitial Enrollment",
                amount: "12,00,000",
                percentageChange: "+3.4%",
                note: "Good For Business",
                noteColor: "color-greenColor",
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Body;
